// extracted by mini-css-extract-plugin
export default {"root":"page-header_root_aH8Fz"};